import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "dsa_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Delay to avoid flash during initial paint
    const t = setTimeout(() => {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = (value) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ accepted: value, at: new Date().toISOString() }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Consentement cookies"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[color:var(--gold)]/40 bg-black/95 backdrop-blur-xl"
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <Cookie size={22} className="gold shrink-0" />
        <p className="text-sm text-gray-300 leading-relaxed flex-1">
          Nous utilisons uniquement les cookies techniques strictement
          nécessaires au fonctionnement du site (session, panier de réservation).
          Aucun cookie de suivi publicitaire n'est déposé.{" "}
          <Link to="/confidentialite" className="gold underline hover:no-underline">
            En savoir plus
          </Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            data-testid="cookie-decline"
            onClick={() => accept(false)}
            className="text-xs uppercase tracking-widest text-gray-400 hover:text-white transition-colors px-3 py-2"
          >
            Refuser
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => accept(true)}
            className="btn-gold text-sm"
          >
            J'ai compris
          </button>
          <button
            aria-label="Fermer"
            onClick={() => accept(false)}
            className="text-gray-500 hover:text-white p-2"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
